import { Tooltip } from 'antd';
import React from 'react';
import styled from 'styled-components';

const StyledContent = styled(Tooltip)``;

const StyledTooltip = ({ borderRadius = '4px', ...props }) => {
  return (
    <StyledContent
      {...props}
      overlayInnerStyle={{
        ...props.overlayInnerStyle,
        borderRadius: borderRadius,
      }}
    />
  );
};

export default StyledTooltip;